// extracted by mini-css-extract-plugin
export default {"searchIcon":"searchContact_searchIcon__vyQhw","wrapper":"searchContact_wrapper__Mn8Fu","input":"searchContact_input__GTPnm","submitBtn":"searchContact_submitBtn__pr894"};